import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { version } from "../package.json";

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
document.head.insertAdjacentHTML(
	"afterbegin",
	`<!-- Version: ${version} -->`,
);